import { MenuItemType } from '@common/types';

export const SIDEBAR_MENU_ITEMS: MenuItemType[] = [
  {
    slug: 'main',
    label: 'Main',
    isTitle: true,
    children: [
      {
        slug: 'dashboard',
        label: 'Dashboard',
        icon: 'dashboard',
        url: '/dashboard',
      },
      {
        slug: 'guests',
        label: 'Guests',
        icon: 'groups',
        children: [
          { slug: 'guests-manage', label: 'Manage', url: '/guests/manage' },
          { slug: 'guests-unsubscribe', label: 'Unsubscribe', url: '/guests/unsubscribe' },
          { slug: 'guests-exception-list', label: 'Exception List', url: '/guests/exception-list' },
        ],
      },
      {
        slug: 'reviews',
        label: 'Reviews',
        icon: 'reviews',
        url: '/reviews',
      },
      {
        slug: 'communications',
        label: 'Communications',
        icon: 'forum',
        url: '/communications',
      },
    ],
  },
  {
    slug: 'tools',
    label: 'Tools',
    isTitle: true,
    children: [
      {
        slug: 'service-tickets',
        label: 'Service Tickets',
        icon: 'confirmation_number',
        url: '/service-tickets',
      },
      {
        slug: 'department-management',
        label: 'Departments',
        icon: 'apartment',
        url: '/department-management',
      },
      {
        slug: 'ai-analytics',
        label: 'AI Analytics',
        icon: 'query_stats',
        children: [
          {
            slug: 'sentiment-overview',
            label: 'Sentiment Overview',
            url: '/sentiment/overview',
            requiresFeature: 'sentiment',
          },
          {
            slug: 'sentiment-by-comment',
            label: 'Sentiment By Comment',
            url: '/sentiment/by-comment',
            requiresFeature: 'sentiment',
          },
          {
            slug: 'ai-analytics-overview',
            label: 'Overview',
            url: '/ai-analytics/overview',
            requiresFeature: 'ai-analytics',
          },
          {
            slug: 'ai-analytics-themes',
            label: 'Themes',
            url: '/ai-analytics/themes',
            requiresFeature: 'ai-analytics',
          },
          {
            slug: 'ai-analytics-keywords-by-theme',
            label: 'Keywords By Theme',
            url: '/ai-analytics/keywords-by-theme',
            requiresFeature: 'ai-analytics',
          },
          {
            slug: 'ai-analytics-people-things',
            label: 'People & Things',
            url: '/ai-analytics/people-things',
            requiresFeature: 'ai-analytics',
          },
          {
            slug: 'ai-analytics-emotions',
            label: 'Emotions',
            url: '/ai-analytics/emotions',
            requiresFeature: 'ai-analytics',
          },
          {
            slug: 'ai-analytics-action-items',
            label: 'Action Items',
            url: '/ai-analytics/action-items',
            requiresFeature: 'ai-analytics',
          },
        ],
      },
      {
        slug: 'reports',
        label: 'Reports',
        icon: 'summarize',
        url: '/reports',
      },
      {
        slug: 'milestones',
        label: 'Milestones',
        icon: 'flag',
        url: '/milestones',
      },
    ],
  },
  {
    slug: 'admin',
    label: 'Admin',
    isTitle: true,
    children: [
      {
        slug: 'accounts',
        label: 'Accounts',
        icon: 'apartment',
        url: '/accounts',
      },
      {
        slug: 'organization',
        label: 'Organisations',
        icon: 'corporate_fare',
        url: '/organizations',
      },
      {
        slug: 'help-center',
        label: 'Help Center',
        icon: 'help',
        url: '/help-center',
      },
    ],
  },
];
